import SettingsField from '@common/forms/SettingsField'
import { usePermissionText, useTranslate } from '@common/hooks'
import cx from 'classnames'
import { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import classNames from './styles.module.scss'

interface IProps {
  permissions?: IPermissionKeyed[]
}

PermissionsCollapse.defaultProps = {
  permissions: undefined,
}

export default function PermissionsCollapse({ permissions }: IProps): JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const { watch } = useFormContext()
  const { translate } = useTranslate()
  const { getPermissionText } = usePermissionText()
  const permissionFormValues = watch(['videoPanel', 'rewriteMessages', 'tipOptions']).filter(p => p !== undefined)

  const permissionText = useMemo(() => {
    const permissionCount = permissionFormValues.filter(x => x).length
    if(permissionCount === 0) { return translate('No permissions granted.') }
    if(permissionCount === permissions?.length) { return translate('All permissions granted.') }
    return translate('Some permissions granted.')
  }, [permissionFormValues, permissions])

  return (
    <>
      {Boolean(permissions?.length) && (
        <div onClick={() => setIsCollapsed(!isCollapsed)} className={classNames.container}>
          <span className={classNames.title} data-test="permissions-title">{translate('Permissions')}</span>
          <span className={classNames.permissionText} data-test="permissions-text">{permissionText}</span>
          <span className={cx(classNames.arrow, isCollapsed && classNames.rotate)} data-test="permissions-arrow"/>
        </div>)}
      {
        !isCollapsed && permissions?.map((permission, ind) => (
          <SettingsField
            type="permission"
            name={permission.key}
            key={permission.key}
            label={translate(permission.label)}
            description={getPermissionText(permission)}
            data-test={`${permission.key}-field`}
            tabIndex={300 + ind}
          />
        ))
      }
    </>
  )
}
